module.exports = __webpack_public_path__ + "img/erqi5.8d4f0b3a.png";